import { Switch, Redirect, useRouteMatch } from 'react-router-dom';
import AuthRoute from '../../utils/auth/authRoute';
import React from 'react';
import { FinanceEntitiesOverview } from '../../pages/financeEntities/overview';

const appendUrl = (url, append) => {
    return url.endsWith('/') ? `${url}${append}` : `${url}/${append}`;
};

export const FinanceEntitiesRouter = ({ organizationId }) => {
    const { path, url } = useRouteMatch();

    return (
        <Switch>
            <AuthRoute allow={['RoleCapacity.ADMIN', 'RoleCapacity.OWNER']} exact path={path} render={() => <Redirect to={appendUrl(url, 'overview')} push={false} />} />
            <AuthRoute
                exact
                allow={['RoleCapacity.ADMIN', 'RoleCapacity.OWNER']}
                path={`${path}/overview`}
                render={() => <FinanceEntitiesOverview organizationId={organizationId} />}
            />
        </Switch>
    );
};
